import { JoggApiOption } from "../client"

export const buckarooGetOrderViewBase = ({ execute, setToken }: Pick<JoggApiOption, "execute" | "setToken">) => {
    return async <S>(orderId: string): Promise<S> => {
        const requestWithToken = await setToken({
            method: "GET",
            uri: `/ctp/order/${orderId}/order-view`,
        })
        return execute(requestWithToken)
    }
}
